import React from "react";
import BreadcrumbConstructor from "components/Breadcrumb";
import { PlantsTable } from "components/Table/PlantsTable";
import config from "/app/src/config.js";

const isMobileOnly = config.mbl_version;

export default function PagePlantsDelete({ ...props }) {
    return (
        <>
            <div className={`content-header row ${isMobileOnly && "row-mbl"}`}>
                {!isMobileOnly && (
                    <BreadcrumbConstructor
                        crumbs={[
                            { id: "dashboard" },
                            { id: "plants" },
                            {
                                id: "delete",
                                text: "Eliminar",
                                disabled: true
                            }
                        ]}
                    />
                )}
            </div>

            <div className="content-body mb-1">
                <PlantsTable
                    {...props}
                    deleteMode={true}
                />
            </div>
        </>
    );
}